// Packages
import PropTypes from 'prop-types'

// Components
import ContractForm from 'modules/Contracts/components/Form';

// Other
import useApi from 'hooks/useApi';

const ContractEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/contracts/' + itemId + '?with=schedule');

	const submit = async (values) => {

        if( await updateItem(values, 'Contract updated!')) {

            onSubmit();
        }
    }

    return(
        <ContractForm 
            errors={errors} 
            contract={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

ContractEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

ContractEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default ContractEditScreen;